module.exports = __webpack_public_path__ + "static/media/tool2.73376561.jpg";